import { IrregularPaymentOffer } from '@/services/generated/client';

/* eslint-disable camelcase */
export enum FormSteps {
  Crossroad,
  Loan,
  Person,
  ThankYou,
  RealEstate,
  Documents,
}

export interface CustomerLoanData {
  value: string;
  installmentValue: string;
}

export interface InvestmentLoanData extends CustomerLoanData {
  purpose: string;
}

export interface Address {
  whole_address: string;
}

export interface CustomerPersonData {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  phoneE164?: string;
  birthNumber: string;
  permanentAddress: Address | null;
  identityCard: string;
  haveRealty: boolean;
  realtyAddress: Address | null;
}

export interface InvestmentPersonData extends CustomerPersonData {
  selfEmployedCompany: string;
}

export interface SetPersonField {
  field: keyof CustomerPersonData | keyof InvestmentPersonData;
  value: string | Address
}

export type ConfigInterface<KEY = CustomerPersonData & InvestmentPersonData & CustomerLoanData & InvestmentLoanData> = {
  [key in keyof KEY]?: {
    disabled?: boolean
    required?: boolean
  }
}

export enum FormState {
  BasicDealInfo = 'BASIC_DEAL_INFO',
  PersonInfo = 'PERSON_INFO',
  BankingInfo = 'BANKING_INFO',
  CollateralInfo = 'COLLATERAL_INFO',
  Closed = 'CLOSED'
}

export enum FormType {
  ConsumerLoan = 'CONSUMER_LOAN',
  InvestmentLoan = 'INVESTMENT_LOAN',
  ConsumerLoanLeadform = 'CONSUMER_LOAN_LEAD_FORM',
  UniLoanLeadForm = 'UNI_LOAN_LEAD_FORM',
}

export interface FormUTMParams {
  utmSource?: string;
  utmCampaign?: string;
  utmMedium?: string;
}

export interface RawPersonInfo {
  birth_number: string | null;
  collateral_init_confirmed: string | null;
  email: string | null;
  first_name: string | null;
  form_consent: boolean | null;
  identity_card: string | null;
  installment_value: string | null;
  last_name: string | null;
  permanent_address: Address | null;
  phone: string | null;
  value: string | null;
  purpose: string | null;
  self_employed_id: string | null;
  company_id: string | null;
  realty_address: Address | null;
  have_realty: boolean;
  deal_type: FormType;
  debtors: RawPersonInfo[]
}

export interface RetrieveFormFixed {
  data: {
    basic_person_info: RawPersonInfo;
    collateral: RawPersonInfo;
    debtors: RawPersonInfo[];
  },
  createdAt: Date;
  updatedAt: Date;
  token: string;
  type: FormType;
  state: FormState;
  config?: ConfigInterface<RawPersonInfo>;
}

export interface Offer {
  value: number,
  months: number,
  principal: number,
  interest_rate: number,
  installment_value: number
}

export type IrregularOffer = { [key: string]: IrregularPaymentOffer; }

export interface RequisitionAccounts {
  accountsConnected?: boolean
  sufficientTransactions?: boolean
}
